import apiFetch from '../../../utils/apiFetch';

export const createSlowOnHit = async (campaignId, payload) => {
  if (!campaignId) return { status: 'inactive-combat' };
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/slow/apply`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok && !result.status) throw new Error(response.statusText || 'Slow combat state could not be updated.');
  return result;
};
